<template>
  <div>
    <p class="font-bold mt-3 text-lg" style="margin-left: 20px">School Registrations - {{accountName}}</p>
    <div style="padding: 20px;">
      <el-table :data="dataList" style="font-size: 12px;box-sizing: border-box;" empty-text="No Data"
        :highlight-current-row="false" :highlight-selection-row="false" :header-cell-class-name="'custom-head-cell'"
        :cell-style="tableCellstyle" :row-class-name="'custom-row-bg'">
        <el-table-column prop="project.project_ename" label="Program" min-width="220">
          <template slot-scope="scope">
            <div style="display: flex; align-items: center; justify-content: center; width: 100%;font-size: 16px;">
              <span 
                @click="goToProjectDetail(scope.row.project)" 
                style="cursor: pointer; color: #409EFF;">
                {{ scope.row.project.project_ename }}
              </span>
              <i 
                class="el-icon-info" 
                style="margin-left: 5px; color: #409EFF; cursor: pointer; flex-shrink: 0;" 
                @click="goToProjectDetail(scope.row.project)" 
                title="View Project Details">
              </i>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Status" width="120px">
          <template slot-scope="scope">
            <el-tag
              :type="getStudentProgramStatusType(scope.row)"
              size="small">
              {{ getStudentProgramStatusLabel(scope.row) }}
            </el-tag>
            <div v-if="scope.row.application_status === '无需缴费'" style="color: #666; font-size: 11px; margin-top: 4px; line-height: 14px;">
              Fee covered by institution
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Notes" width="240">
          <template slot-scope="scope">
            <span v-if="getRowBu(scope.row) === 'AM'" class="notes-am-text">
              {{ getAmParticipationNote(scope.row) }}
            </span>
            <div
              v-else-if="getRowBu(scope.row) === 'NIM'"
              class="notes-nim-cycles">
              <div
                v-for="cycle in getNimReviewCycles(scope.row)"
                :key="cycle.name || cycle.announce_date"
                class="notes-nim-cycle">
                <div class="notes-nim-cycle-name">{{ getReviewCycleDisplayName(cycle) }}</div>
                <div v-if="cycle.announce_date" class="notes-nim-cycle-date">
                  Results: {{ formatReviewDate(cycle.announce_date) }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Advisor" width="150px">
          <template slot-scope="scope">
            <div v-for="(contact, index) in scope.row.contacts" :key="index">
              <p>{{ formatContactName(contact) }} </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="project.project_ename" label="Operation" width="280">
          <template slot-scope="scope">

            <div class="operations-container">
              <!-- Pending institution payment: Payment Details only (B-2) -->
              <div class="admin-operations" v-if="isInstitutionPaymentPending(scope.row)">
                <el-button
                  type="warning"
                  size="small"
                  @click="viewInstitutionPayment(scope.row)">
                  Payment Details
                </el-button>
              </div>

              <div class="admin-operations" v-else>
                <!-- Primary CTAs -->
                <el-button 
                  type="primary"
                  size="small" 
                  v-if="scope.row.project.project_status == 'active'"
                  @click="goStudentInfo(scope.row)">
                  Manage Students
                </el-button>
                
                <el-button 
                  v-if="scope.row.project.project_status == 'active'" 
                  type="primary"
                  size="small"
                  @click="showCopyLink(scope.row)">
                  Registration Link
                </el-button>

                <!-- Program -->
                <el-dropdown 
                  v-if="hasProgramActions(scope.row)" 
                  trigger="click" 
                  @command="cmd => handleAction(cmd, scope.row)">
                  <el-button plain type="primary" size="small" class="category-button">
                    Program
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item 
                      v-if="scope.row.project.exam_time_arr && scope.row.project.exam_time_arr.length > 0" 
                      command="viewExams">
                      View Exams
                    </el-dropdown-item>
                    <el-dropdown-item 
                      v-if="scope.row.projectManage" 
                      command="viewTimeline">
                      View Timeline
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>

                <el-button
                  v-if="user_type === 'advisor' && scope.row.project.exam_time_arr && scope.row.project.exam_time_arr.length > 0"
                  type="primary"
                  size="small"
                  plain
                  @click="viewStudentsExamStatus(scope.row)">
                  Exam Status
                </el-button>

                <!-- Results -->
                <el-dropdown 
                  v-if="hasResultActions(scope.row)" 
                  trigger="click" 
                  @command="cmd => handleAction(cmd, scope.row)">
                  <el-button plain type="primary" size="small" class="category-button">
                    Results
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item 
                      v-if="canViewSchoolResults(scope.row)" 
                      command="viewResults">
                      View Results
                    </el-dropdown-item>
                    <el-dropdown-item 
                      v-if="checkEnableShowCert(scope.row)" 
                      command="certificate">
                      Certificate
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="checkEnableShowCongratulatoryLetter(scope.row)"
                      command="congratulatoryLetter">
                      Congratulatory Letter
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>

                <!-- Resources: invoice/receipt + cases + brand auth -->
                <el-dropdown 
                  v-if="hasStudentResourceActions(scope.row)"
                  trigger="click" 
                  @command="cmd => handleStudentResourceAction(cmd, scope.row)">
                  <el-button plain type="primary" size="small" class="category-button">
                    Resources
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-if="isInstitutionPaymentPaid(scope.row) || scope.row.application_status === '已缴费' || scope.row.application_status === '部分支付'"
                      command="invoice">
                      Download Invoice
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="scope.row.application_status === '已缴费'"
                      command="receipt">
                      Download Receipt
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="scope.row.application_status === '已缴费' && isInstitutionPaymentEnabled(scope.row)"
                      command="brandAuth">
                      Brand Authorization
                    </el-dropdown-item>
                    <template v-for="(case_item, index) in (scope.row.case_array || [])">
                      <el-dropdown-item 
                        v-if="case_item.case_button_status === 1"
                        :key="'case-' + index"
                        :command="'downloadCase-' + index">
                        {{ case_item.case_title || 'Download Case' }}
                      </el-dropdown-item>
                      <el-dropdown-item 
                        v-if="case_item.case_button_status === 0"
                        :key="'case-disabled-' + index"
                        disabled>
                        Case Not Released
                      </el-dropdown-item>
                    </template>
                  </el-dropdown-menu>
                </el-dropdown>

              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :visible.sync="isShowDialog" title="Assign Advisor" width="600px" @close="closeDialog">
      <div>
        <el-form :inline="true" ref="form">
          <el-form-item label="Select program advisor(s)">
            <el-select v-model="selectContactIds" placeholder="Please select" :multiple="true" style="width: 400px;">
              <el-option v-for="(contact, index) in teacherOpt" :key="index" :label="formatContactName(contact)"
                :value="contact._id.$id">
              </el-option>
            </el-select>
          </el-form-item>
          <p>*Emails to students for the project will also go to the assigned program advisor.</p>
        </el-form>
        <div style="width: 100%; text-align: center; margin-top: 30px">
          <el-button size="medium" @click="isShowDialog = false">Cancel</el-button>
          <el-button type="primary" size="medium" @click="saveInfo()">Confirm</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="isShowCopyDialog" title="Student Registration Link" width="50%">
      <div class="content">
        <div style="padding: 0 10px">Please copy and share the link with your student for registration</div>
        <div class="linkbox" style="display: flex;width: 100%">
          <span class="link">{{ linkStr }}</span>
          <el-button type="primary" size="medium" @click="copyLink">Copy</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="showViewExamsDialog" width="70%">
      <div style="margin-top: 0px;width: 100%;padding: 0px 20px;">
        <p style="text-align: center;color: #ff6450;font-size: 28px;font-weight: bold;">View Exams</p>
        <p style="font-size:16px;text-align: center;margin-top: 20px;">
          You may only enter the exam between Entry Open Time and Entry Close Time.<br>
          The exam timer starts only when you enter, and you will have the full exam time from then on.
        </p>
      </div>
      <div style="margin-top: 0px;width: 100%;padding: 0px 20px;" 
           v-if="viewProject.account_application?.custom_exam_time != '是' && viewProject.student_supplementary_exam_time != '是'">
        <h2 style="text-align: center;margin-top: 20px;">{{viewProject.project_ename}}</h2>
        <p style="font-size:16px;text-align: center;margin-top: 20px;">
          The dates and times for Entry Open and Entry Close refer to the local time of each continent where your school is located.<br>
          (Asia &amp; Oceania: GMT+8, Europe &amp; Africa: GMT+1, North &amp; South America: GMT-4).
          <br>If you will be travelling internationally, you need to apply for custom exam time.
        </p>
        <p style="font-size:16px;text-align: center;margin-top: 20px;">The mock test is a test for you to get familiar with the system and functions, and the most important objective is to test your equipment to ensure they work well.</p>
        <el-table :data="viewProject.exam_time_arr" style="width: 100%; margin-top: 20px;">
          <el-table-column prop="name" label="Exam Name" align="center">
            <template slot-scope="scope">
              <span style="word-break: keep-all; hyphens: none; white-space: normal;">{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Time to Exam" align="center">
            <template slot-scope="scope">
              <span :style="getCountdownStyle(getCountdownForStandard(scope.row))">{{getCountdownForStandard(scope.row)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Entry Open Time" align="center">
            <template slot-scope="scope">
              <span style="word-break: keep-all; hyphens: none; white-space: normal;">{{scope.row.exam_begin_time_str}} {{studentTimezone}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Entry Close Time" align="center">
            <template slot-scope="scope">
              <span style="word-break: keep-all; hyphens: none; white-space: normal;">{{scope.row.exam_end_time_str}} {{studentTimezone}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="viewProject.account_application?.custom_exam_time == '是' ">
        <h2 style="text-align: center;margin-top: 20px;">Custom Exam Time of Your School</h2>
        <div style="font-size:16px;text-align: center;margin-top: 20px;">
          <p>If your school has applied for a custom exam time per our policies,<br>please refer to your school's custom schedule.</p>
        </div>
        <el-table :data="getMergedExamTimeArray()" style="width: 100%; margin-top: 20px;">
          <el-table-column prop="event_name" label="Exam Name" align="center">
            <template slot-scope="scope">
              <span style="word-break: keep-all; hyphens: none; white-space: normal;">{{scope.row[0]?.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Time to Exam" align="center">
            <template slot-scope="scope">
              <span :style="getCountdownStyle(getCountdownForCustom(scope.row))">{{getCountdownForCustom(scope.row)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Entry Open Time" align="center">
            <template slot-scope="scope">
              <span style="word-break: keep-all; hyphens: none; white-space: normal;">{{scope.row[0]?.event_start_time ? convertTimeToEng(scope.row[0].event_start_time) : ''}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Entry Close Time" align="center">
            <template slot-scope="scope">
              <span style="word-break: keep-all; hyphens: none; white-space: normal;">{{scope.row[0]?.event_end_time ? convertTimeToEng(scope.row[0].event_end_time) : ''}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="Status" align="center">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row[0].status === 'approved' ? 'success' : 
                       scope.row[0].status === 'pending' ? 'warning' : 'info'">
                {{ scope.row[0].status === 'approved' ? 'Approved' :
                   scope.row[0].status === 'pending' ? 'Pending Review' : scope.row[0].status === 'standard' ? 'Standard' : 'Not Submitted' }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 20px; text-align: center;">
        <el-button type="primary" size="medium" style="margin-right: 10px;" @click="openAdviserCustomTestTimeDialog">
          Apply for Custom Test Time
        </el-button>
        <el-button type="primary" size="medium" @click="openExamSystem()">
          Go to the Remote Exam System
        </el-button>
        <p style="margin-top: 10px;">The login credentials will be the same as those for this EAE system.</p>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="showTimelineDialog" title="Project Timeline" width="70%">
      <div style="margin-top: 0px;width: 100%;padding: 0px 20px;">
        <p style="text-align: center;color: #ff6450;font-size: 28px;font-weight: bold;">
          {{ timelineProject?.project_ename || 'Project Timeline' }}
        </p>
        
        <el-table :data="timelineData" style="width: 100%; margin-top: 20px;">
          <el-table-column prop="name" label="Phase" align="center">
            <template slot-scope="scope">
              <span style="word-break: keep-all; hyphens: none; white-space: normal;">{{scope.row.name}}</span>
            </template>
          </el-table-column>
          
          <el-table-column prop="ddl_date_str" align="center">
            <template slot="header">
              <span>Deadline for<br>Student Exam/Work Entry</span>
            </template>
            <template slot-scope="scope">
              <span style="word-break: keep-all; hyphens: none; white-space: normal;">{{scope.row.ddl_date_str}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="announce_date_str" label="Results Announcement" align="center">
            <template slot-scope="scope">
              <span style="word-break: keep-all; hyphens: none; white-space: normal;">{{scope.row.announce_date_str}}</span>
            </template>
          </el-table-column>
          
          <el-table-column label="Status" align="center">
            <template slot-scope="scope">
              <span :style="{color: getStatusColor(scope.row), 'word-break': 'keep-all', 'hyphens': 'none', 'white-space': 'normal'}">
                {{ getCurrentStatus(scope.row) }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        
        <div style="font-size: 14px; margin-top: 20px; color: #606266;">
          <p class="no-word-break">* All dates are shown in your local timezone.</p>
          <p class="no-word-break">** Please make sure to complete submissions of exams/works before the deadlines.</p>
          <p class="no-word-break">*** There will be a period between submission deadlines and result announcements for grading, score verification and manual processing to ensure accuracy of results. Thank you for your patience during this time.</p>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="showAdviserCustomTestTimeDialog" title="Request School Custom Test Time" width="80%">
      <div style="margin-top: 0px; width: 100%; padding: 0px 20px;">
        <div class="custom-time-policy">
          <p class="custom-time-policy__title">Custom test time policy</p>
          <ul class="custom-time-policy__list">
            <li>A custom test time no more than {{ customExamAutoApproveDays }} days before or after the standard test time is automatically approved.</li>
            <li>A request more than {{ customExamAutoApproveDays }} days from the standard test time is an exception request and will normally be rejected. Approval is considered only for serious, unavoidable circumstances.</li>
            <li>Scheduled classes, other projects or competitions, extracurricular activities, personal travel, work, and other obligations do not qualify for an exception.</li>
            <li>This request will apply to all students from your school for this project.</li>
          </ul>
          <p style="margin: 0; line-height: 1.6;">
                        * If you only need to customize some of the sessions, please keep the other sessions with the standard time unchanged.
                    </p>
        </div>
        <p style="text-align: center; color: #ff6450; font-size: 24px; font-weight: bold;">
          {{ viewProject?.project_ename }}
        </p>
        
        <el-table :data="viewProject.student_event_meeting_room_array ? Object.values(viewProject.student_event_meeting_room_array) : []" style="width: 100%; margin-top: 20px;">
          
          <el-table-column prop="" label="Exam Name" align="center" width="200px">
            <template slot-scope="scope">
              <span style="word-break: keep-all; hyphens: none; white-space: normal;">{{scope.row[0]?.name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="Exam Type" align="center" width="150px">
            <template slot-scope="scope">
              <span style="word-break: keep-all; hyphens: none; white-space: normal;">{{scope.row[0].type}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="Time Zone" align="center" width="200px">
            <template slot-scope="scope">
              <el-select v-model="scope.row[0].timezone">
                <el-option v-for="(zone,index) in timezones" :key="index" :label="zone" :value="zone"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column prop="" label="Exam Open Time" align="center" width="200px">
            <template slot-scope="scope">
              <el-date-picker
                :value="getAdjustedTimeByTimezone(scope.row[0].event_start_time, scope.row[0].timezone)"
                @input="updateEventTime($event, scope.row[0])"
                type="datetime"
                placeholder="Please select"
                format="yyyy-MM-dd HH:mm"
                value-format="timestamp">
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column prop="" label="Exam Close Time" align="center" width="200px">
            <template slot-scope="scope">
              <span style="word-break: keep-all; hyphens: none; white-space: normal;">
                {{ convertTimeToEngByTimezone(scope.row[0].event_start_time + scope.row[0].duration, scope.row[0].timezone) }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="custom-time-reason">
        <p class="custom-time-reason__title">Exception reason</p>
        <p class="custom-time-reason__help">
          Leave this section blank if every selected session is within {{ customExamAutoApproveDays }} days of the standard test time. As a rule, requests outside the {{ customExamAutoApproveDays }}-day window are rejected unless they fall under one of the exceptional circumstances listed below. Selecting a reason and providing details does not guarantee approval.
        </p>
        <el-select
          v-model="adviserCustomTestTimeForm.reasonCategory"
          placeholder="Select only if exception review is required"
          style="width: 100%; margin-bottom: 12px;">
          <el-option
            v-for="option in customExamExceptionReasons"
            :key="option.value"
            :label="option.label"
            :value="option.value">
          </el-option>
        </el-select>
        <el-input
          type="textarea"
          v-model="adviserCustomTestTimeForm.reasonDetails"
          :rows="4"
          :placeholder="'Describe what happened, the relevant dates, and why the school cannot use a test time within the ' + customExamAutoApproveDays + '-day window.'"
          style="width: 100%">
        </el-input>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <div style="display: flex; justify-content: center; gap: 20px;">
          <el-button @click="showAdviserCustomTestTimeDialog = false">Cancel</el-button>
          <el-button
            type="primary"
            :loading="adviserCustomTestTimeSubmitting"
            :disabled="adviserCustomTestTimeSubmitting"
            @click="submitAdviserCustomTestTime">
            Submit Request
          </el-button>
        </div>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="showStudentsExamStatusDialog" width="70%" title="Student Exam Status">
      <div style="padding: 0 20px;">
        <p style="text-align: center; font-size: 18px; font-weight: bold; margin-bottom: 8px;">
          {{ examStatusProject.project_ename || examStatusProject.project_name }}
        </p>
        <p style="text-align: center; color: #666; margin-bottom: 20px;">
          Exam completion status for students registered under you
        </p>
        <el-table
          v-loading="examStatusLoading"
          :data="studentsExamStatusList"
          style="width: 100%;"
          empty-text="No students found">
          <el-table-column prop="student_name" label="Student" align="center" min-width="160" />
          <el-table-column prop="student_email" label="Email" align="center" min-width="180" />
          <el-table-column label="Mock Test" align="center" width="140">
            <template slot-scope="scope">
              <el-tag :type="getExamStatusTagType(scope.row.mock_status)" size="small">
                {{ scope.row.mock_status }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="Formal Exam" align="center" width="140">
            <template slot-scope="scope">
              <el-tag :type="getExamStatusTagType(scope.row.formal_status)" size="small">
                {{ scope.row.formal_status }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  updateAccountApplicationContacts,
  getContactsByAccount,
  getSchoolRegistrations,
  getAdvisorStudentsExamStatus,
  postRequest,
  generateCrossLoginToken
} from '../../api/eae'
import {
  getUserId,
  getUserType,
  getAccountId,
  setTargetType,
  getAccountName,
  getAccountContinent
} from '../../utils/store'
import {
  CUSTOM_EXAM_AUTO_APPROVE_DAYS,
  CUSTOM_EXAM_EXCEPTION_REASONS
} from '../../utils/customExamTimePolicy'
import { normalizeCustomExamWindow } from '../../utils/customExamTimeWindow'
import {
  formatReviewDate,
  getReviewCycleDisplayName,
  getRegistrationRowBu,
  getAmParticipationNote,
  getNimReviewCyclesForNotes
} from '../../utils/registrationNotes'
export default ({
  name: 'index',
  data() {
    return {
      user_type: getUserType(),
      dataList: [],
      isShowDialog: false,
      teacherOpt: [],
      rowData: {},
      isShowCopyDialog: false,
      linkStr: '',
      selectContactIds: [],
      showViewExamsDialog: false,
      viewProject: {},
      accountName: getAccountName(),
      showTimelineDialog: false,
      timelineProject: null,
      timelineData: [],
      // Custom test time dialog properties
      showAdviserCustomTestTimeDialog: false,
      adviserCustomTestTimeSubmitting: false,
      adviserCustomTestTimeForm: {
        reasonCategory: '',
        reasonDetails: ''
      },
      customExamAutoApproveDays: CUSTOM_EXAM_AUTO_APPROVE_DAYS,
      customExamExceptionReasons: CUSTOM_EXAM_EXCEPTION_REASONS,
      timezones: [],
      countdownTimer: null,
      nowTimestamp: Date.now(),
      studentTimezone: '',
      showStudentsExamStatusDialog: false,
      examStatusLoading: false,
      studentsExamStatusList: [],
      examStatusProject: {}
    }
  },
  mounted() {
    this.fetchData()
    this.getSubjectList()
    setTargetType('student')
    // Initialize timezones
    this.initializeTimezones()
    this.countdownTimer = setInterval(() => {
      this.nowTimestamp = Date.now()
    }, 1000)
  },
  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer)
    }
  },
  methods: {
    getReviewCycleDisplayName,
    formatReviewDate,
    getAmParticipationNote,
    getRowBu(row) {
      return getRegistrationRowBu(row)
    },
    getNimReviewCycles(row) {
      return getNimReviewCyclesForNotes(row)
    },
    getMergedExamTimeArray() {
      if (!this.viewProject?.account_application?.event_meeting_room_array) return []
      let obj = JSON.parse(JSON.stringify(this.viewProject.account_application.event_meeting_room_array))
      // 把未定制的 session 用标准时间补上
      if (this.viewProject.exam_time_arr) {
        for (let i = 0; i < this.viewProject.exam_time_arr.length; i++) {
          let exam = this.viewProject.exam_time_arr[i]
          if (!obj[exam.name]) {
            let new_item = {}
            new_item['event_start_time'] = exam.exam_begin_time
            new_item['event_end_time'] = exam.exam_end_time
            new_item['name'] = exam.name
            new_item['type'] = exam.exam_type
            new_item['status'] = 'standard'
            obj[exam.name] = [new_item]
          }
        }
      }
      return Object.values(obj)
    },
    gotoAwardView(row){
      let id = row._id.$id
      this.$router.push({
        path:'/advisorAward',
        query:{
          id:id
        }
      })
    },

    gotoCongratulatoryLetter(row){
      let id = row._id.$id
      const contacts = Array.isArray(row.application_contacts) ? row.application_contacts : []
      const userId = getUserId()
      let advisor_id = ''
      if (userId && contacts.some((contactId) => contactId == userId)) {
        advisor_id = userId
      } else if (contacts.length) {
        advisor_id = contacts[0]
      } else if (userId) {
        advisor_id = userId
      }
      const query = { id }
      if (advisor_id) {
        query.advisor_id = advisor_id
      }
      this.$router.push({
        path: '/congratulatoryLetter',
        query
      })
    },

    checkEnableShowCert(row){
      let project = row.project
      let user_id = getUserId()
      let validUser = false
      if(row.application_contacts && row.application_contacts.length >0){
        row.application_contacts.forEach(contact_id => {
            if(contact_id == user_id){
              validUser = true
            }
        });
      }
      // NIM 没有配置老师证书，不显示 Certificate 入口
      if (getRegistrationRowBu(row) === 'NIM') {
        return false
      }
      return project.project_status != 'active' && validUser == true
    },

    checkEnableShowCongratulatoryLetter(row){
      let project = row.project || {}
      if (project.project_congratulatory_letter_show != 'show') {
        return false
      }
      let user_id = getUserId()
      let validUser = false
      if (row.application_contacts && row.application_contacts.length > 0) {
        row.application_contacts.forEach(contact_id => {
          if (contact_id == user_id) {
            validUser = true
          }
        })
      }
      return validUser
    },

    gotoViewStudentResults(row) {
      this.$router.push({
        path: '/home/studentResults',
        query: {
          project:row.project.project_ename,
          project_id: row.project._id.$id,
          account_id: getAccountId()
        }
      })
    },

    formatContactName(contact) {
      if (!contact) return '';
      const capitalizeWords = str => str.split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');

      if (contact.contact_enName) {
        return capitalizeWords(contact.contact_enName);
      }

      const lastName = capitalizeWords(contact.contact_lastName || '');
      const givenName = capitalizeWords(contact.contact_givenName || '');
      return `${lastName} ${givenName}`;
    },

    getStudentProgramStatusType(row) {
      const status = row.application_status
      const crmStatuses = ['未接触', '待跟进', '促单中', '宣传中', '困难户', '搁置中', '接触中']
      if (crmStatuses.includes(status)) {
        return 'warning'
      }
      if (status === '待缴费' || status === '部分支付') {
        return 'warning'
      }
      if (status === '已缴费' || status === '无需缴费' || status === '已报名') {
        if (row.project && row.project.project_status === 'active') {
          return 'success'
        }
        return 'info'
      }
      if (row.project && row.project.project_status === 'active') {
        return 'success'
      }
      return 'info'
    },

    getStudentProgramStatusLabel(row) {
      const status = row.application_status
      const crmStatusMap = {
        '未接触': 'Not Contacted',
        '待跟进': 'Follow Up',
        '促单中': 'In Progress',
        '宣传中': 'Promoting',
        '困难户': 'Difficult',
        '搁置中': 'On Hold',
        '接触中': 'In Contact'
      }
      if (crmStatusMap[status]) {
        return crmStatusMap[status]
      }
      // School day / institution payment: show real payment status
      if (status === '待缴费') {
        return 'Pending Payment'
      }
      if (status === '部分支付') {
        return 'Partially Paid'
      }
      if (status === '已缴费') {
        return 'Paid'
      }
      if (status === '无需缴费') {
        return 'No Payment Required'
      }
      if (row.project && row.project.project_status === 'active') {
        return 'Registered'
      }
      return 'Completed'
    },

    getSubjectList() {
      this.teacherOpt = []
      getContactsByAccount(getAccountId()).then((res) => {
        if (res && res.data && Array.isArray(res.data) && res.data.length > 0) {
          this.teacherOpt = res.data
        } else {
          console.warn('getContactsByAccount returned non-array data:', res);
          this.teacherOpt = [];
        }
      }).catch(err => {
        console.error('Error fetching contacts:', err);
        this.teacherOpt = [];
      })
    },
    fetchData() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      getSchoolRegistrations(getAccountId(), 'student').then((res) => {
        // Check if res.data exists and is an array
        if (res && res.data && Array.isArray(res.data)) {
          this.dataList = res.data
            .filter((item) => {
              const bu = item.project && item.project.project_BU
                ? String(item.project.project_BU).toUpperCase()
                : ''
              return bu !== 'DSA'
            })
            .map(item => {
            item.case_array = this.processApplicationCases(item);
            return item;
          });
        } else {
          // Handle case where data is not an array or doesn't exist
          console.warn('getSchoolRegistrations returned non-array data:', res);
          this.dataList = [];
          if (res && res.data && typeof res.data === 'object') {
            // If it's an object with a data property, try to extract array
            if (Array.isArray(res.data.data)) {
              this.dataList = res.data.data.map(item => {
                item.case_array = this.processApplicationCases(item);
                return item;
              });
            }
          }
        }
        loading.close()
      }).catch(err => {
        console.error('Error fetching school registrations:', err);
        this.dataList = [];
        this.$message.error('Failed to load school registrations. Please try again.');
        loading.close()
      })
    },
    tableCellstyle() {
      return 'background:  #FAE3E4;border:1px solid white;text-align:center; font-family: Ubuntu-Bold;'
    },

    getTimezoneOffsetMs(timezone) {
      if (!timezone || timezone === 'GMT+8') return 0
      if (timezone === 'GMT+1') return 7 * 60 * 60 * 1000
      if (timezone === 'GMT-4') return 12 * 60 * 60 * 1000
      return 0
    },
    getCountdownForStandard(row) {
      if (!row.exam_begin_time) return '-'
      let openTime = row.exam_begin_time
      if (openTime.toString().length === 10) openTime = openTime * 1000
      let endTime = row.exam_end_time
      if (endTime && endTime.toString().length === 10) endTime = endTime * 1000
      let offset = this.getTimezoneOffsetMs(this.studentTimezone)
      openTime += offset
      if (endTime) endTime += offset
      return this.formatCountdown(openTime, endTime)
    },
    getCountdownForCustom(row) {
      if (!row[0]?.event_start_time) return '-'
      let openTime = row[0].event_start_time
      if (openTime.toString().length === 10) openTime = openTime * 1000
      let endTime = row[0]?.event_end_time
      if (endTime && endTime.toString().length === 10) endTime = endTime * 1000
      return this.formatCountdown(openTime, endTime)
    },
    formatCountdown(openTime, endTime) {
      const now = this.nowTimestamp
      if (endTime && now >= endTime) return 'Ended'
      if (now >= openTime) return 'Open Now'
      const diff = openTime - now
      const days = Math.floor(diff / (1000 * 60 * 60 * 24))
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((diff % (1000 * 60)) / 1000)
      if (days > 0) return `${days}d ${hours}h ${minutes}m`
      if (hours > 0) return `${hours}h ${minutes}m ${seconds}s`
      return `${minutes}m ${seconds}s`
    },
    getCountdownStyle(text) {
      if (text === 'Open Now') return 'color: #67C23A; font-weight: bold;'
      if (text === 'Ended') return 'color: #909399;'
      return 'color: #E6A23C; font-weight: bold;'
    },
    convertTimeToEng(time) {
        var date = new Date(time * 1000);
        date = new Date(date.getTime()); // Convert to UTC
        let year = date.getUTCFullYear();
        let month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
        let day = date.getUTCDate().toString().padStart(2, '0');
        let hours = date.getUTCHours().toString().padStart(2, '0');
        let minutes = date.getUTCMinutes().toString().padStart(2, '0');
        let seconds = date.getUTCSeconds().toString().padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} UTC`;
    },

    formatMonthToEng(month) {
      switch (month) {
        case 1:
          return "January";
        case 2:
          return "February";
        case 3:
          return "March";
        case 4:
          return "April";
        case 5:
          return "May";
        case 6:
          return "June";
        case 7:
          return "July";
        case 8:
          return "August";
        case 9:
          return "September";
        case 10:
          return "October";
        case 11:
          return "November";
        case 12:
          return "December";
      }
    },
    showDialog(data) {
      this.rowData = data
      this.selectContactIds = []
      this.isShowDialog = true
    },

    closeDialog() {
    },
    saveInfo() {
      if (this.selectContactIds.length <= 0) {
        this.$message.warning('Please select advisors')
        return
      }
      let oldContacts = [];
      // if (this.rowData.application_contacts && this.rowData.application_contacts.length > 0) {
      //   oldContacts = this.rowData.application_contacts
      // }
      let newContacts = this.selectContactIds.concat(oldContacts)
      //合并之后，
      const uniqueContacts = [...new Set(newContacts)]
      updateAccountApplicationContacts(this.rowData._id.$id, uniqueContacts).then((res) => {
        this.$message.success('Assign Advisor Successful')
        this.isShowDialog = false
        this.fetchData()
      })
    },
    goStudentInfo(data) {
      this.$router.push({
        path: '/home/manageStudentList',
        query: {
          project_id: data.project_id,
          project_code: data.project.project_code,
          project_name: data.project.project_ename ? data.project.project_ename : data.project.project_name
        }
      })
    },
    showCopyLink(data) {
      if (!data || !data.project) {
        this.$message.warning('Registration link is not available')
        return
      }
      let user_type = getUserType()
      // Institution registration forms (including DSA) are hosted on the EAE form app.
      // DSA students are redirected to my.dsaexam.com only after successful confirm.
      // AM forms need participation_arrangement or institution_app_id to show the institution landing.
      let url = 'https://my.eae.international/#/form/registration?account_id=' + data.account_id
        + '&project_code=' + data.project.project_code
      if (data.participation_arrangement === 'School day') {
        url += '&institution_app_id=' + data._id.$id
      } else {
        url += '&participation_arrangement=Standard%20registration'
      }
      if (user_type == 'advisor') {
        let contact_id = getUserId()
        url += '&contact_id=' + contact_id + '&advisor_id=' + contact_id
      }
      this.linkStr = url
      this.isShowCopyDialog = true
    },
    isInstitutionPaymentPending(row) {
      return row && row.participation_arrangement === 'School day'
        && (row.application_status === '待缴费' || row.application_status === '部分支付')
    },
    isInstitutionPaymentEnabled(row) {
      return !!(row && (
        row.institution_payment_enabled === 'YES'
        || (row.project && row.project.institution_payment_enabled === 'YES')
        || row.participation_arrangement === 'School day'
      ))
    },
    isInstitutionPaymentPaid(row) {
      return row && row.participation_arrangement === 'School day' && row.application_status === '已缴费'
    },
    hasStudentResourceActions(row) {
      if (!row) return false
      if (this.isInstitutionPaymentPaid(row) || row.application_status === '已缴费' || row.application_status === '部分支付') {
        return true
      }
      return !!(row.case_array && row.case_array.length > 0)
    },
    handleStudentResourceAction(command, row) {
      if (command === 'invoice') {
        this.downloadInstitutionInvoice(row, 'invoice')
        return
      }
      if (command === 'receipt') {
        this.downloadInstitutionInvoice(row, 'receipt')
        return
      }
      if (command === 'brandAuth') {
        this.openBrandAuthorization(row)
        return
      }
      this.handleCaseAction(command, row)
    },
    openBrandAuthorization(row) {
      if (!row || !row._id) {
        this.$message.warning('Brand authorization not available')
        return
      }
      this.$router.push({
        path: '/home/brandAuthorization',
        query: {
          application_id: row._id.$id
        }
      })
    },
    viewInstitutionPayment(row) {
      if (!row || !row._id) {
        this.$message.warning('Payment details not available')
        return
      }
      this.$router.push({
        path: '/home/program-order',
        query: {
          application_id: row._id.$id
        }
      })
    },
    downloadInstitutionInvoice(row, documentMode = 'invoice') {
      if (!row || !row._id) {
        this.$message.warning('Invoice not available')
        return
      }
      this.$router.push({
        path: '/home/schoolInvoice',
        query: {
          id: row._id.$id,
          document: documentMode
        }
      })
    },

    handleAction(command, row) {
      switch (command) {
        case 'viewExams':
          this.viewExams(row)
          break
        case 'viewTimeline':
          this.viewTimeline(row)
          break
        case 'viewResults':
          this.gotoViewStudentResults(row)
          break
        case 'certificate':
          this.gotoAwardView(row)
          break
        case 'congratulatoryLetter':
          this.gotoCongratulatoryLetter(row)
          break
      }
    },
    viewStudentsExamStatus(row) {
      if (this.user_type !== 'advisor') {
        return
      }
      this.examStatusProject = row.project || {}
      this.studentsExamStatusList = []
      this.showStudentsExamStatusDialog = true
      this.examStatusLoading = true
      getAdvisorStudentsExamStatus(getUserId(), getAccountId(), row.project_id).then((res) => {
        if (res.data && res.data.code === 0) {
          this.studentsExamStatusList = res.data.data || []
        } else {
          this.$message.error(res.data?.msg || 'Failed to load exam status')
        }
      }).catch(() => {
        this.$message.error('Failed to load exam status')
      }).finally(() => {
        this.examStatusLoading = false
      })
    },
    getExamStatusTagType(status) {
      if (status === 'Completed') {
        return 'success'
      }
      if (status === 'Not Completed') {
        return 'danger'
      }
      return 'info'
    },
    hasProgramActions(row) {
      return (row.project.exam_time_arr && row.project.exam_time_arr.length > 0) || !!row.projectManage
    },
    // AM-01: an admin can open this school's results before the project
    // publishes them ("Open school results" on the institution registration).
    // NIM projects additionally require the admin score switch
    // (project_score_show) so results stay hidden until it is turned on.
    canViewSchoolResults(row) {
      if (row.exam_open_school_results === 'YES') return true
      if (row.project.project_status != 'inactive') return false
      if (getRegistrationRowBu(row) === 'NIM') return row.project.project_score_show == 'show'
      return true
    },
    hasResultActions(row) {
      return this.canViewSchoolResults(row)
        || this.checkEnableShowCert(row)
        || this.checkEnableShowCongratulatoryLetter(row)
    },
    handleCaseAction(command, row) {
      if (command.startsWith('downloadCase-')) {
        const index = parseInt(command.replace('downloadCase-', ''))
        const caseItem = row.case_array[index]
        if (caseItem && caseItem.case_material_url) {
          this.downloadCase(caseItem.case_material_url)
        }
      }
    },
    copyLink() {
      let that = this
      navigator.clipboard.writeText(this.linkStr)
        .then(function () {
          that.isShowCopyDialog = false
          that.$message.success('Copy Success');
        })
        .catch(function (err) {
          console.error('Failed to copy text: ', err);
        });
    },
    processApplicationCases(application) {
      let case_array = [];
      if (application.project && application.project.case_time_arr) {
        for (let i = 0; i < application.project.case_time_arr.length; i++) {
          let case_button_status = -1;
          let case_title = '';
          let case_material_url = '';

          let item = application.project.case_time_arr[i];
          let case_release_time = item.case_release_time;
          case_material_url = item.case_material_url;
          
          let current_time = parseInt(new Date().getTime() / 1000);
          if (current_time > case_release_time) {
            case_title = item.case_title;
            case_button_status = 1;
          } else {
            case_button_status = 0;
          }
          
          case_array.push({
            case_button_status,
            case_title,
            case_material_url
          });
        }
      }
      return case_array;
    },
    downloadCase(url) {
      if (url) {
        window.open(url, '_blank');
      } else {
        this.$message.warning('Case material not available');
      }
    },
    overlayPendingApplies(pendingApplies, targetMap) {
      if (!pendingApplies || !targetMap) return
      // targetMap 内时间单位为秒（与数据库一致），pending 记录也是秒，直接覆盖即可
      for (const apply of pendingApplies) {
        const examTime = apply.exam_time || {}
        for (const key in examTime) {
          const items = examTime[key]
          if (!items || !items[0]) continue
          const raw = items[0]
          let start_time = raw.event_start_time
          let end_time = raw.event_end_time
          // 若上游给的是毫秒，统一为秒
          if (start_time && start_time.toString().length === 13) {
            start_time = parseInt(start_time / 1000)
          }
          if (end_time && end_time.toString().length === 13) {
            end_time = parseInt(end_time / 1000)
          }
          const existing = (targetMap[key] && targetMap[key][0]) ? targetMap[key][0] : {}
          const merged = Object.assign({}, existing, {
            event_start_time: start_time,
            event_end_time: end_time,
            timezone: raw.timezone || existing.timezone,
            name: raw.name || existing.name || key,
            type: raw.type || existing.type,
            status: 'pending'
          })
          this.$set(targetMap, key, [merged])
        }
      }
    },
    viewExams(row) {
      this.viewProject = row.project

      // Initialize exam data structure for custom test time dialog
      let obj = [];
      let timezone = this.getDefaultTimezone(row.account_continent || getAccountContinent() || 'Asia')
      this.studentTimezone = timezone
      for(let i=0; i<row.project.exam_time_arr.length;i++){
        let item = row.project.exam_time_arr[i]
        let array = [];
        let new_item = {}
        new_item['event_start_time'] = this.formatExamTimeByTimezone(timezone,item.exam_begin_time) * 1000
        new_item['event_end_time'] = this.formatExamTimeByTimezone(timezone,item.exam_end_time) * 1000
        new_item['name'] = item.name
        new_item['type'] = item.exam_type
        new_item['duration'] = new_item['event_end_time'] - new_item['event_start_time']
        new_item['timezone'] = timezone
        array.push(new_item)
        obj[item.name] = array
      }
      this.$set(this.viewProject, 'student_event_meeting_room_array', obj)

      postRequest({
        function: 'getAccountApplicationByContact',
        contact_id: getUserId(),
        project_code: row.project.project_code
      }).then(res => {
        if (res.data.data) {
          this.$set(this.viewProject, 'account_application', res.data.data)
          console.log('Account application loaded:', this.viewProject.account_application);

          // 合并account级pending申请：在Pending状态下 getMergedExamTimeArray 展示"申请时间"+Pending Review
          const accountPendings = res.data.data.account_pending_applies || []
          if (accountPendings.length > 0) {
            if (this.viewProject.account_application.custom_exam_time != '是') {
              this.$set(this.viewProject.account_application, 'custom_exam_time', '是')
            }
            if (!this.viewProject.account_application.event_meeting_room_array) {
              this.$set(this.viewProject.account_application, 'event_meeting_room_array', {})
            }
            this.overlayPendingApplies(accountPendings, this.viewProject.account_application.event_meeting_room_array)
          }

          // Check if there's existing custom exam time data
          if(this.viewProject.account_application?.custom_exam_time == '是'){
            console.log('Found existing custom exam time data');
            let obj = {};
            let keys = Object.keys(this.viewProject.account_application.event_meeting_room_array)
            for(let i=0; i<keys.length;i++ ){
              let key = keys[i]
              let originalItem = this.viewProject.account_application.event_meeting_room_array[key]
              let item = JSON.parse(JSON.stringify(originalItem))
              const standardExam = (row.project.exam_time_arr || []).find(exam => exam.name === key)
              item[0] = normalizeCustomExamWindow(item[0], standardExam)
              obj[key]= item
            }
            // 未定制的 session 用标准时间补上
            if(row.project.exam_time_arr){
              for(let i=0; i<row.project.exam_time_arr.length; i++){
                let exam = row.project.exam_time_arr[i]
                if(!obj[exam.name]){
                  let new_item = {}
                  new_item['event_start_time'] = this.formatExamTimeByTimezone(timezone, exam.exam_begin_time) * 1000
                  new_item['event_end_time'] = this.formatExamTimeByTimezone(timezone, exam.exam_end_time) * 1000
                  new_item['name'] = exam.name
                  new_item['type'] = exam.exam_type
                  new_item['duration'] = new_item['event_end_time'] - new_item['event_start_time']
                  new_item['timezone'] = timezone
                  new_item['status'] = 'standard'
                  obj[exam.name] = [new_item]
                }
              }
            }
            this.$set(this.viewProject, 'student_event_meeting_room_array', obj)
            console.log('Updated student_event_meeting_room_array with existing data:', this.viewProject.student_event_meeting_room_array);
          }
        } else {
          console.log('No account application data found');
        }
      }).catch(err => {
        console.error('Error getting account application:', err)
      })

      this.showViewExamsDialog = true
    },
    openExamSystem() {
      if(this.viewProject.project_BU == 'WAO'){
        window.open('https://my.academic-olympics.world', '_blank')
      } else if(this.viewProject.project_BU == 'AM'){
        let user_id = getUserId()
        let user_type = getUserType()
        const projectCode = this.viewProject.project_code || ''
        generateCrossLoginToken(user_id, user_type, 'AM', projectCode).then(res => {
          if (res.data.code === 0) {
            let token = res.data.data.token
            let examUrl = 'https://arena.academic-marathon.org/#/login?cross_token=' + encodeURIComponent(token)
              + '&user_id=' + encodeURIComponent(user_id)
              + '&user_type=' + encodeURIComponent(user_type)
            if (projectCode) {
              examUrl += '&project_code=' + encodeURIComponent(projectCode)
            }
            window.open(examUrl, '_blank')
          } else {
            window.open('https://arena.academic-marathon.org', '_blank')
          }
        }).catch(() => {
          window.open('https://arena.academic-marathon.org', '_blank')
        })
      } else {
        window.open('https://exam.learningfirst.io', '_blank')
      }
    },
    viewTimeline(row) {
      this.timelineProject = row.project;
      this.timelineData = [];
      
      if (row.projectManage && row.projectManage.entry_date) {
        // Format dates for display
        this.timelineData = row.projectManage.entry_date.map(item => {
          const ddl_date_str = item.ddl_date ? this.formatDate(item.ddl_date) : 'N/A';
          const announce_date_str = item.announce_date ? this.formatDate(item.announce_date) : 'N/A';
          
          return {
            ...item,
            ddl_date_str,
            announce_date_str
          };
        });
      }
      
      this.showTimelineDialog = true;
    },
    formatDate(timestamp) {
      const date = new Date(timestamp);
      const gmt8Date = new Date(date.getTime() + (8 * 60 * 60 * 1000));
      const utcString = gmt8Date.toUTCString();
      return utcString.split(' ').slice(1, 4).join(' ');
    },
    getCurrentStatus(item) {
      const currentTime = Date.now();
      
      if (!item.ddl_date) return 'Unknown';
      
      if (currentTime < item.ddl_date + (24 * 60 * 60 * 1000)) {
        return 'In Progress';
      } else if (item.announce_date && currentTime < item.announce_date) {
        return 'Under Review';
      } else {
        return 'Completed';
      }
    },
    getStatusColor(item) {
      const status = this.getCurrentStatus(item);
      
      switch (status) {
        case 'In Progress':
          return '#409eff'; // Blue
        case 'Under Review':
          return '#e6a23c'; // Orange
        case 'Completed':
          return '#67c23a'; // Green
        default:
          return '#909399'; // Gray
      }
    },
    goToProjectDetail(project) {
      this.$router.push({
        path: '/home/programsDetail',
        query: {
          project_id: project._id.$id,
          from:'adviser'
        }
      })
    },
    initializeTimezones() {
      for(let i=-12;i<=14;i++){
        if(i == 0){
          this.timezones.push('GMT+0')
        }else {
          if(i > 0) {
            this.timezones.push('GMT+'+(i-0.5))
            this.timezones.push('GMT+'+i)
          }else {
            this.timezones.push('GMT'+i)
            this.timezones.push('GMT'+(i+0.5))
          }
        }
      }
    },
    openAdviserCustomTestTimeDialog() {
      // Reset form
      this.adviserCustomTestTimeForm.reasonCategory = '';
      this.adviserCustomTestTimeForm.reasonDetails = '';
      this.showAdviserCustomTestTimeDialog = true;

      console.log(this.viewProject.account_application);
    },
    submitAdviserCustomTestTime() {
      if (this.adviserCustomTestTimeSubmitting) return
      if (!this.viewProject.student_event_meeting_room_array) {
        this.$message.error('Exam data not available. Please try viewing exams again.');
        return;
      }

      let project_code = this.viewProject.project_code
      let obj = {};
      let keys = Object.keys(this.viewProject.student_event_meeting_room_array)
      
      if (keys.length === 0) {
        this.$message.error('No exam data found. Please try viewing exams again.');
        return;
      }

      for(let i=0; i<keys.length;i++ ){
        let key = keys[i]
        let item = this.viewProject.student_event_meeting_room_array[key]
        if (!item || !item[0]) {
          this.$message.error('Invalid exam data structure. Please try viewing exams again.');
          return;
        }
        
        let array = [];
        let new_item = {}
        const standardExam = (this.viewProject.exam_time_arr || []).find(exam => exam.name === key)
        const normalizedItem = normalizeCustomExamWindow(item[0], standardExam)
        let start_time = normalizedItem.event_start_time
        let end_time = normalizedItem.event_end_time
        let name = normalizedItem.name
        let type = normalizedItem.type
        let timezone = normalizedItem.timezone
        
        if(!start_time || start_time == '' ){
          this.$message.warning('Please select exam open time.')
          return
        }
        if(!normalizedItem.duration || end_time <= start_time){
          this.$message.error('The exam close time for ' + (name || key) + ' must be later than its open time.')
          return
        }
        if(!timezone || timezone == '' ){
          this.$message.warning('Please select timezone.')
          return
        }

        new_item['event_start_time'] =  parseInt(start_time / 1000)
        new_item['event_end_time'] = parseInt(end_time/ 1000)
        new_item['name'] = name
        new_item['type'] = type
        new_item['timezone'] = timezone
        array.push(new_item)
        obj[key] = array                 
        this.$set(item, 0, normalizedItem)
      }
      
      let params = {
        account_id: getAccountId(),
        contact_id: getUserId(),
        project_code: project_code,
        custom_exam_time: "是",
        event_meeting_room_array: obj,
        reason: this.adviserCustomTestTimeForm.reasonDetails.trim(),
        reason_category: this.adviserCustomTestTimeForm.reasonCategory,
        reason_details: this.adviserCustomTestTimeForm.reasonDetails.trim(),
        apply_type: 'account',
        contact_id: getUserId(),
        application_id: this.viewProject.account_application._id.$id,
        expected_custom_exam_time_version: this.viewProject.account_application.custom_exam_time_version || ''
      }
      
      this.adviserCustomTestTimeSubmitting = true
      postRequest({
        function: 'requestStudentCustomTestTime',
        ...params
      }).then(res => {
        this.adviserCustomTestTimeSubmitting = false
        if (res.data && res.data.code === 0) {
          const resultData = res.data.data || {};
          const autoApproved = resultData.auto_approved || [];
          const pending = resultData.pending || [];
          const autoApproveDays = resultData.auto_approve_days || this.customExamAutoApproveDays;
          const msgParts = [];
          if (autoApproved.length > 0) {
            msgParts.push('<b>Auto-approved (within ' + autoApproveDays + ' days of standard time):</b><br>' + autoApproved.join(', '));
          }
          if (pending.length > 0) {
            msgParts.push('<b>Submitted for review:</b><br>' + pending.join(', '));
          }
          const msg = msgParts.length > 0
            ? msgParts.join('<br><br>')
            : 'Your school custom test time request has been submitted.';
          this.$alert(msg, 'Custom Test Time Request Result', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: 'I understand',
            callback: () => {
              this.showAdviserCustomTestTimeDialog = false;
              this.showViewExamsDialog = false;
              this.fetchData();
            }
          });
        } else if (res.data && res.data.code === -4) {
          this.$alert(
            res.data.msg || 'This school schedule was updated by another user. Please review the latest time before submitting again.',
            'School Schedule Updated',
            {
              type: 'warning',
              confirmButtonText: 'Refresh schedule',
              callback: () => {
                this.showAdviserCustomTestTimeDialog = false;
                this.showViewExamsDialog = false;
                this.fetchData();
              }
            }
          );
        } else if (res.data && res.data.code === -3) {
          this.$message.warning(res.data.msg || 'Please provide an exception reason for test times outside the 5-day window');
        } else {
          this.$message.error('Failed to submit request: ' + (res.data?.msg || 'Unknown error'));
          this.showAdviserCustomTestTimeDialog = false;
          this.showViewExamsDialog = false;
          this.fetchData();
        }
      }).catch(err => {
        this.adviserCustomTestTimeSubmitting = false
        console.error('Error submitting custom test time request:', err);
        this.$message.error('Failed to submit request. Please try again.');
        this.showAdviserCustomTestTimeDialog = false;
        this.showViewExamsDialog = false;
        this.fetchData();
      });
    },
    getLocalTimezone() {
      // Get the local timezone offset in hours
      const offset = new Date().getTimezoneOffset() / -60;
      return `GMT${offset >= 0 ? '+' : ''}${offset}`;
    },
    getAdjustedTimeByTimezone(time, timezone) {
      if (!timezone) return time;
      const offset = parseFloat(timezone.replace('GMT', ''));

      const local_timezone = parseFloat(this.getLocalTimezone().replace('GMT', ''))

      return time + ((offset - local_timezone) * 60 * 60 * 1000);
    },
    updateEventTime(newTime, row) {
      if (!row.timezone) {
        row.event_start_time = newTime;
        if (Number(row.duration) > 0) {
          row.event_end_time = newTime + Number(row.duration);
        }
        return;
      }

      // Get timezone offset in hours FIRST
      const tzOffset = parseFloat(row.timezone.replace('GMT', ''));
      
      // Get the user's selected date/time in their timezone
      const userSelectedDate = new Date(newTime);
      console.log('User selected date/time:', userSelectedDate);

      // Get the date components
      const year = userSelectedDate.getFullYear();
      const month = userSelectedDate.getMonth();
      const date = userSelectedDate.getDate();
      
      // Get the time components
      const hours = userSelectedDate.getHours();
      const minutes = userSelectedDate.getMinutes();

      // Create date in UTC then adjust for timezone
      const tzDate = new Date(Date.UTC(year, month, date, hours, minutes));
      
      // Apply timezone offset ONCE
      const timestamp = tzDate.getTime() - tzOffset * 60 * 60 * 1000;
      
      console.log('Timezone adjusted timestamp:', timestamp);
      console.log('For timezone:', row.timezone);
      
      row.event_start_time = timestamp;
      if (Number(row.duration) > 0) {
        row.event_end_time = timestamp + Number(row.duration);
      }
    },
    convertTimeToEngByTimezone(time, timezone) {
      const local_timezone = parseFloat(this.getLocalTimezone().replace('GMT', ''))

      if (timezone) {
          const offset = parseFloat(timezone.replace('GMT', ''));
          time = time + ((offset-local_timezone) * 60 * 60 * 1000);
      }
      let date = new Date(time);
      date = new Date(date.getTime()); // Convert to UTC
      let year = date.getFullYear();
      let month = (date.getMonth() + 1).toString().padStart(2, '0');
      let day = date.getDate().toString().padStart(2, '0');
      let hours = date.getHours().toString().padStart(2, '0');
      let minutes = date.getMinutes().toString().padStart(2, '0');
      
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    getDefaultTimezone(account_continent){
      if(account_continent == 'Asia' || account_continent == 'Oceania'){
        return 'GMT+8'
      }
      if(account_continent == 'Europe' || account_continent == 'Africa') {
        return 'GMT+1'
      }
      if(account_continent == 'North America' || account_continent == 'South America') {
        return 'GMT-4'
      }
      return ''
    },
    formatExamTimeByTimezone(timezone,exam_time){
      if(!timezone){
        return exam_time
      }
      const offset = parseFloat(timezone.replace('GMT', ''))
      if(isNaN(offset)){
        return exam_time
      }
      return exam_time + Math.round((8 - offset) * 3600)
    },
  }
})
</script>
<style scoped lang="scss">
/deep/ .el-table .custom-row-bg {
  background: #FAE3E4;
}

/deep/ .el-table tbody .cell {
  font-family: Ubuntu-Light;
}

/deep/ .el-table .custom-head-cell {
  background: var(--c-primary);
  color: white;
  text-align: center;
  border: 1px solid white;
  box-sizing: border-box;
  font-family: Ubuntu-Bold;
}

.linkbox {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 14px;
  gap: 10px;

  .link {
    flex: auto;
    display: inline-block;
    padding: 0 10px;
    line-height: 36px;
    background: #f2f2f2;
    border-radius: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.operations-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.admin-operations {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 4px;

    .el-button {
        margin: 0;  /* Override element-ui default margins */
    }
}

.case-operations {
    display: flex;
    flex-direction: column;
    gap: 8px;
    border-top: 1px solid #ebeef5;
    padding-top: 8px;
}

.case-operation-row {
    display: flex;
    align-items: center;
    gap: 8px;
}

.case-buttons {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;

    .el-button {
        margin: 0;  /* Override element-ui default margins */
    }
}

/deep/ .el-button--mini {
    padding: 7px 12px;
    font-size: 12px;
}

/* Ensure consistent button heights */
/deep/ .el-button {
    line-height: 1.2;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

/* Make sure table cells can accommodate the content */
/deep/ .el-table__row td {
    padding: 8px;
}

/* Improve text wrapping in */
.no-word-break {
  word-break: keep-all;  /* Prevent breaking words */
  white-space: normal;   /* Allow wrapping at spaces */
  hyphens: none;         /* Disable hyphenation */
}

.custom-time-policy {
  margin-bottom: 20px;
  padding: 16px 18px;
  background: #f4f4f5;
  border-radius: 4px;
  color: #303133;
}

.custom-time-policy,
.custom-time-reason {
  word-break: normal;
  overflow-wrap: break-word;
  hyphens: none;
}

.custom-time-policy__title,
.custom-time-reason__title {
  margin: 0 0 8px;
  font-weight: 600;
}

.custom-time-policy__list {
  margin: 0 0 10px;
  padding-left: 20px;
  line-height: 1.65;
}

.custom-time-reason {
  margin: 20px 0 0;
  padding: 16px 18px;
  background: #fafafa;
  border-radius: 4px;
}

.custom-time-reason__help {
  margin: 0 0 12px;
  color: #606266;
  font-size: 13px;
  line-height: 1.55;
}

/* Category buttons - white background with theme-colored border and font */
.category-button {
  background-color: white !important;
  border-color: #409EFF !important;
  color: #409EFF !important;
}

.category-button:hover {
  background-color: #ecf5ff !important;
  border-color: #66b1ff !important;
  color: #66b1ff !important;
}

.notes-am-text {
  display: inline-block;
  max-width: 100%;
  white-space: normal;
  word-break: break-word;
  line-height: 1.35;
  font-size: 11px;
}

.notes-nim-cycles {
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: left;
  font-size: 11px;
  line-height: 1.35;
}

.notes-nim-cycle {
  min-width: 0;
}

.notes-nim-cycle-name {
  font-weight: 600;
}

.notes-nim-cycle-date {
  color: #666;
}
</style>
